
import { Layout } from "@/components/Layout/Layout";

export default function Privacy() {
  return (
    <Layout>
      <div className="container max-w-4xl py-12 px-4 mx-auto animate-fade-in">
        <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
        
        <div className="prose prose-sm sm:prose max-w-none">
          <p className="lead">This Privacy Policy describes how ThePromptSpace collects, uses, and shares your personal information when you use our platform.</p>
          
          <h2>1. Information We Collect</h2>
          <p>We collect information you provide directly to us when you:</p>
          <ul>
            <li>Create an account (username, email, password)</li>
            <li>Complete your profile (bio, avatar)</li>
            <li>Post content (prompts, comments)</li>
            <li>Interact with other users (likes, follows)</li>
            <li>Communicate with us</li>
          </ul>
          
          <p>We also automatically collect certain information when you use our platform, including:</p>
          <ul>
            <li>Device information</li>
            <li>Usage data</li>
            <li>IP address</li>
            <li>Cookies and similar technologies</li>
          </ul>
          
          <h2>2. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Provide, maintain, and improve our platform</li>
            <li>Create and manage your account</li>
            <li>Process transactions</li>
            <li>Send you technical notices and support messages</li>
            <li>Respond to your comments and questions</li>
            <li>Develop new features and services</li>
            <li>Monitor and analyze trends and usage</li>
            <li>Detect, investigate, and prevent fraudulent transactions and other illegal activities</li>
          </ul>
          
          <h2>3. How We Share Your Information</h2>
          <p>We may share your information with:</p>
          <ul>
            <li>Other users (your public profile, prompts, and comments)</li>
            <li>Service providers who perform services on our behalf</li>
            <li>Legal authorities when required by law</li>
            <li>Third parties in connection with a merger, sale, or acquisition</li>
          </ul>
          
          <h2>4. Your Rights and Choices</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access, update, or delete your personal information</li>
            <li>Object to processing of your personal information</li>
            <li>Data portability</li>
            <li>Withdraw consent</li>
          </ul>
          
          <h2>5. Data Security</h2>
          <p>We implement appropriate technical and organizational measures to protect your personal information from unauthorized access, loss, or disclosure.</p>
          
          <h2>6. International Data Transfers</h2>
          <p>Your information may be transferred to, and processed in, countries other than the country in which you reside. These countries may have data protection laws that are different from your country.</p>
          
          <h2>7. Children's Privacy</h2>
          <p>Our platform is not intended for children under 13 years of age, and we do not knowingly collect personal information from children under 13.</p>
          
          <h2>8. Changes to This Privacy Policy</h2>
          <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.</p>
          
          <h2>9. Contact Us</h2>
          <p>If you have any questions about this Privacy Policy, please contact us at privacy@thepromptspace.com.</p>
          
          <p className="text-sm text-muted-foreground mt-8">Last updated: April 4, 2025</p>
        </div>
      </div>
    </Layout>
  );
}
